import {HTMLAttributes, ReactNode} from 'react'
import {StyledAccountModalSection, StyledAccountModalSectionTitle, StyledAccountModalHeader} from './style'

export const AccountModalHeader = (props: HTMLAttributes<HTMLDivElement>) => <StyledAccountModalHeader {...props} />

export const AccountModalSection = ({title, children}: {title: string; children: ReactNode}) => {
    return (
        <StyledAccountModalSection>
            <StyledAccountModalSectionTitle>{title}</StyledAccountModalSectionTitle>
            {children}
        </StyledAccountModalSection>
    )
}
